import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1E3F33] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {/* Brand */}
          <div className="mb-3">
            <img
              src="/Images/logo_white.png"
              alt="Logo" 
              className="mb-4 h-8 w-auto"
            />
            <p className="text-sm text-[#8FA998] leading-relaxed">
              Gynecologic Oncologist in Kolkata specializing in ovarian, cervical, and uterine cancer treatment with advanced surgical techniques.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2">

              <li>
                <Link
                  to="/about"
                  data-testid="footer-link-about"
                  className="text-sm text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors duration-200"
                >
                  About
                </Link>
              </li>

              <li>
                <Link
                  to="/specialities"
                  data-testid="footer-link-specialities"
                  className="text-sm text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors duration-200"
                >
                  Specialities
                </Link>
              </li>

              <li>
                <Link
                  to="/hospitals"
                  data-testid="footer-link-hospitals"
                  className="text-sm text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors duration-200"
                >
                  Hospitals
                </Link>
              </li>

              <li>
                <Link
                  to="/testimonials"
                  data-testid="footer-link-testimonials"
                  className="text-sm text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors duration-200"
                >
                  Testimonials
                </Link>
              </li>

              <li>
                <Link
                  to="/faq"
                  data-testid="footer-link-faq"
                  className="text-sm text-[#F9F9F6]/70 hover:text-[#F9F9F6] transition-colors duration-200"
                >
                  FAQ
                </Link>
              </li>

            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase text-[#8FA998] mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-[#F9F9F6]/70">
                <Phone className="w-4 h-4 text-[#8FA998]" />
                <a href="tel:+916291000829" data-testid="footer-phone" className="hover:text-[#F9F9F6] transition-colors">
                  +91 6291000829
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-[#F9F9F6]/70">
                <Mail className="w-4 h-4 text-[#8FA998]" />
                <a href="mailto:consult@drnehaagarwalonco.com" data-testid="footer-email" className="hover:text-[#F9F9F6] transition-colors">
                  consult@drnehaagarwalonco.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-sm text-[#F9F9F6]/70">
                <MessageCircle className="w-4 h-4 text-[#8FA998]" />
                <a
                  href="https://wa.me/916291000829"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-[#F9F9F6] transition-colors"
                >
                  WhatsApp Consultation
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-[#F9F9F6]/70">
                <MapPin className="w-4 h-4 text-[#8FA998] mt-0.5" />
                <span>Kolkata, West Bengal, India</span>
              </li>
            </ul>
          </div>
        </div>

        {/* SEO Section */}
        <div className="border-t border-[#F9F9F6]/10 pt-8 mb-8">
          <h3
            data-testid="footer-seo-heading"
            className="font-serif text-lg text-[#F9F9F6]/50 mb-3"
          >
            Gynecologic Oncologist in Kolkata | Ovarian & Uterine Cancer Specialist
          </h3>
          <p className="text-xs text-[#F9F9F6]/30 leading-relaxed max-w-3xl">
            If you are looking for an experienced gynecologic oncologist in Kolkata for ovarian cancer, cervical cancer, uterine cancer, or HIPEC surgery, Dr. Neha Agarwal offers specialized care with advanced treatment options. Serving patients across: Mukundapur, EM Bypass, Garia, Kasba, Ballygunge, Salt Lake and nearby areas.
          </p>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#F9F9F6]/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#F9F9F6]/30" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Dr. Neha Agarwal. All rights reserved.
          </p>
          <p className="text-xs text-[#F9F9F6]/20">
            Gynecologic Oncologist &bull; Kolkata, India
          </p>
        </div>
      </div>
    </footer>
  );
}
